import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        trainingForm: '=',
        courseId: '=',
        scormTraining: '='
    },
    template: `
        <div class="modal-header" id="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'course.scorm.Files' | translate }}</h2>
        </div><h1>{{vm.selectedScormName}} {{vm.selectedScormId}}</h1>
        <div class="modal-body">
            <div class="table-filters" ng-if="vm.view!=='modal'">
                <form class="form form-filter" ng-submit="vm.applyFilter()">
                    <div class="fields">
                        <div class="row row-flex02 row-md row-separated">
                            <label class="label">{{ 'filter.Name' | translate }}</label>
                            <div class="items">
                                <input type="text" ng-model="vm.filter.name" class="form-control">
                            </div>
                        </div>
                    </div>
                    <ul class="actions01">
                        <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                        <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                    </ul>
                </form>
            </div>
            <div>
                <pagination-tools list="vm.list" custom-options="[1000]"></pagination-tools>
                <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
                <div class="" ng-if="!vm.list.loading && vm.list.items.length">
                    <courses-courses-steps-version-scorm-table
                        selected-scorm-id="vm.scormId"
                        selected-scorm-name="vm.scormName"
                        items="vm.list.items"
                    />
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        ng-disabled="!vm.scormId"
                        class="btn main"
                        type="button"
                        ng-click="vm.select()"
                     >{{ 'course.scorm.Use selected file' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, ModalService, ListFactory, FormFactory,
        ScormResource) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.ModalService = ModalService;
        this.ListFactory = ListFactory;
        this.FormFactory = FormFactory;
        this.list = ListFactory.createWithPagination(ScormResource.query.bind(ScormResource));
        this.scormId = this.scormTraining.scormId;
        this.scormName = this.scormTraining.scormFileName;
    }

    $onInit () {
        this.resetFilter();
    }

    applyFilter () {
        this.list.fetch(this.filter, this.filter);
    }

    resetFilter () {
        this.filter = { expand: 'courses.activeI18n' };
        this.filter.courseId = this.courseId;
        this.applyFilter();
    }

    select () {
        this.scormTraining.scormFile = null;
        this.scormTraining.scormId = this.scormId;
        this.scormTraining.scormFileName = this.scormName;
        this.scormTraining.useExistingFile = true;
        this.scormTraining.isEnabled = true;
        this.uibModalInstance.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/version/training/scormFiles/index.js